import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { useState, useRef } from "react";
import { toast } from "react-toastify";
import { mask, unMask } from "remask";
import { useAuth } from "../contexts/AuthInfoContext";
import { Api } from "../services/Api";
import axios from "axios";
import { validarEstado } from "../utils/ValidaUF";

function AtualizarEnderecoDialog(props) {
  const { user_id } = useAuth();

  const [form, setForm] = useState({
    endereco_cep: "",
    endereco_rua: "",
    endereco_numero: "",
    endereco_complemento: "",
    endereco_bairro: "",
    endereco_cidade: "",
    endereco_estado: "",
  });

  const [loadingCep, setLoadingCep] = useState(false);
  const lastCepRef = useRef(null);

  const handleChange = (field, value) => {
    setForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const buscarCep = async (cep) => {
    const cepLimpo = unMask(cep);

    if (cepLimpo.length !== 8) return;
    if (lastCepRef.current === cepLimpo) return;

    lastCepRef.current = cepLimpo;

    try {
      setLoadingCep(true);

      const { data } = await axios.get(`https://viacep.com.br/ws/${cepLimpo}/json/`);

      if (data.erro) {
        toast.error("CEP não encontrado");
        return;
      }

      setForm((prev) => ({
        ...prev,
        endereco_rua: data.logradouro || prev.endereco_rua,
        endereco_bairro: data.bairro || prev.endereco_bairro,
        endereco_cidade: data.localidade || prev.endereco_cidade,
        endereco_estado: data.uf || prev.endereco_estado,
      }));
    } catch {
      toast.error("Erro ao buscar CEP");
    } finally {
      setLoadingCep(false);
    }
  };

  const validar = () => {
    if (!form.endereco_cep || unMask(form.endereco_cep).length !== 8)
      return "CEP inválido";
    if (!form.endereco_rua) return "Rua é obrigatória";
    if (!form.endereco_numero) return "Número é obrigatório";
    if (!form.endereco_bairro) return "Bairro é obrigatório";
    if (!form.endereco_cidade) return "Cidade é obrigatória";
    if (!form.endereco_estado) return "Estado é obrigatório";
    if (!validarEstado(form.endereco_estado)) return "UF inválida"

    return null;
  };

  const atualizarEndereco = async (event) => {
    event.preventDefault();

    const erro = validar();
    if (erro) {
      toast.error(erro);
      return;
    }

    const payload = {
      usuario_id: user_id,
      ...form,
      endereco_cep: unMask(form.endereco_cep),
    };

    await toast.promise(
      Api.post("/endereco/createDevedor", payload),
      {
        pending: "Atualizando endereço...",
        success: "Endereço atualizado com sucesso!",
        error: "Erro ao atualizar endereço",
      }
    );

    props.close();
    props.next();
  };

  return (
    <Dialog
      visible
      onHide={() => props.close()}
      header="Atualizar Endereço"
      style={{
        height: window.innerHeight > 900 ? "70vh" : "90vh",
        width: window.innerWidth > 900 ? "50vw" : "100vw",
      }}
      className="boletosDialog"
    >
      <div className="p-[1vh]">

        <form onSubmit={atualizarEndereco} className="flex flex-col gap-2">

          <h7 className="mb-4 text-red-500">
            * Para gerar o boleto é necessário atualizar o seu endereço <br/>
            * Os campos marcados com (*) são obrigatórios <br/>
            * Informe seu CEP para preencher automaticamente o endereço <br/>
          </h7>
          {/* CEP */}
          <div className="flex flex-col gap-1">
            <label>CEP *</label>
            <InputText
              value={form.endereco_cep}
              onChange={(e) => {
                const masked = mask(unMask(e.target.value), ["99999-999"]);
                handleChange("endereco_cep", masked);
                buscarCep(masked);
              }}
              placeholder="00000-000"
            />
          </div>

          {/* Rua */}
          <div className="flex flex-col gap-1">
            <label>Rua *</label>
            <InputText
              value={form.endereco_rua}
              onChange={(e) => handleChange("endereco_rua", e.target.value)}
              placeholder="Ex: Av. Paulista"
            />
          </div>

          {/* Número + Complemento */}
          <div className="flex gap-4">
            <div className="flex flex-col gap-1 w-1/3">
              <label>Número *</label>
              <InputText
                value={form.endereco_numero}
                onChange={(e) =>
                  handleChange("endereco_numero", e.target.value)
                }
                placeholder="Ex: 123"
              />
            </div>

            <div className="flex flex-col gap-1 w-2/3">
              <label>Complemento</label>
              <InputText
                value={form.endereco_complemento}
                onChange={(e) =>
                  handleChange("endereco_complemento", e.target.value)
                }
                placeholder="Ex: Apto 45, Bloco B"
              />
            </div>
          </div>

          {/* Bairro */}
          <div className="flex flex-col gap-1">
            <label>Bairro *</label>
            <InputText
              value={form.endereco_bairro}
              onChange={(e) => handleChange("endereco_bairro", e.target.value)}
              placeholder="Ex: Centro"
            />
          </div>

          {/* Cidade + Estado */}
          <div className="flex gap-4">
            <div className="flex flex-col gap-1 w-2/3">
              <label>Cidade *</label>
              <InputText
                value={form.endereco_cidade}
                onChange={(e) =>
                  handleChange("endereco_cidade", e.target.value)
                }
                placeholder="Ex: São Paulo"
              />
            </div>

            <div className="flex flex-col gap-1 w-1/3">
              <label>UF *</label>
              <InputText
                value={form.endereco_estado}
                onChange={(e) =>
                  handleChange("endereco_estado", e.target.value)
                }
                placeholder="Ex: SP"
                maxLength={2}
              />
            </div>
          </div>

          <div className="flex w-full justify-center mt-5">
            <div className="w-1/2">
              <Button
                label={loadingCep ? "Buscando CEP..." : "Salvar Endereço"}
                type="submit"
                className="w-full"
                disabled={loadingCep}
              />
            </div>
          </div>
        </form>
      </div>
    </Dialog>
  );
}

export default AtualizarEnderecoDialog;